<template>
    <div class="container-fluid px-0">

        <AuthNav></AuthNav>

        <NavButtons light-btns></NavButtons>

    </div>

	<div v-show="currentView === 'registration'">
	    <div class="row">
	        <div ref="registerForm" class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 mb-3">
	            <div class="d-flex flex-column gap-3 text-center mb-5">
	                <h3 class="fw-semi-bold m-0">Register</h3>
	                <p class="text-secondary m-0">Use the form below to create an Account.</p>
	            </div>
	            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3" :class="formErrors.email ? 'border-danger' : 'border-secondary'">
	                <label for="email">
	                    <i class="me-3 dd-icon bi bi-envelope-at"></i>
	                </label>
	                <input v-model="email" type="email" id="email" name="email" class="form-control m-0 border-0 fs-5 p-0 lh-fixed" placeholder="Email Address" @input="removeFormErrorKey('email')" >
	            </div>
	            <div v-if="formErrors.email" class="validation-error" v-html="formErrors.email"></div>

	            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3" :class="formErrors.password ? 'border-danger' : 'border-secondary'">
	                <label for="password">
	                    <i class="me-3 dd-icon bi bi-shield-lock"></i>
	                </label>
	                <input v-model="password" :type="passwordToggle ? 'text' : 'password'" id="password" name="password" class="form-control m-0 border-0 fs-5 p-0 lh-fixed" placeholder="Password" @input="removePassErrorKeys" >
	                <span class="rounded-circle" v-ripple>
	                    <i @click="(event) => passwordToggle = !passwordToggle" :class="passwordToggle ? 'bi-eye' : 'bi-eye-slash'" v-ripple></i>
	                </span>
	            </div>
	            <div v-if="formErrors.password" class="validation-error" v-html="formErrors.password"></div>

	            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken my-3" :class="formErrors.password_confirmation ? 'border-danger' : 'border-secondary'">
	                <label for="password_confirmation">
	                    <i class="me-3 dd-icon bi bi-shield-check"></i>
	                </label>
	                <input v-model="password_confirmation" :type="confirmPasswordToggle ? 'text' : 'password'" id="password_confirmation" name="password_confirmation" class="form-control m-0 border-0 fs-5 p-0 lh-fixed" placeholder="Confirm Password" @input="removePassErrorKeys" >
	                <span class="rounded-circle" v-ripple>
	                    <i @click="(event) => confirmPasswordToggle = !confirmPasswordToggle" :class="confirmPasswordToggle ? 'bi-eye' : 'bi-eye-slash'"></i>
	                </span>
	            </div>
	            <div v-if="formErrors.password_confirmation" class="validation-error" v-html="formErrors.password_confirmation"></div>

	<!--            <div class="d-flex align-items-center justify-content-start py-2 px-3 input-container">-->
	<!--                <input v-model="terms" class="form-check-input mt-0 ms-2" id="terms" type="checkbox" name="terms" :class="formErrors.terms ? 'border-danger' : ''" @change="removeFormErrorKey('terms')">-->
	<!--                <label class="form-check-label cursor-pointer p-2 ms-3" for="terms">-->
	<!--                    I accept to all the <a href="/legal/terms_and_conditions" class="text-primary ms-2 cursor-pointer" target="_blank">Terms and Conditions</a> of ExploreMeds.-->
	<!--                </label>-->
	<!--            </div>-->
	            <div v-if="formErrors.terms" class="validation-error" v-html="formErrors.terms"></div>

	            <div class="d-flex flex-column align-items-center justify-content-between text-center mt-3">
	                <button class="btn btn-dark rounded-pill d-flex align-items-center justify-content-center py-2 px-3 w-50" @click="performContentValidation" :disabled="hasFormErrors">
	                    Register <i class="bi bi-arrow-right"></i>
	                </button>

	                <div class="mt-3">
	                    <span class="text-secondary">Already have an account?</span>
	                    <a v-load-page="'/login'" class="text-primary ms-2 cursor-pointer">Login</a>
	                </div>
	            </div>

	            <!-- <hr />

	            <div class="d-flex align-items-center justify-content-center py-2 px-3 input-container my-3">
	                <span class="text-secondary">Or Register using one of the Social Platforms</span>
	            </div>

	            <Social></Social> -->

	        </div>
	    </div>

		<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" id="termsModal" aria-labelledby="termsModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered sheetModal popOutModal">
				<div class="modal-content rounded-sm">
					<div class="modal-body d-flex flex-column p-4 align-items-center">
						<div class="d-flex justify-content-center" v-if="showTerms || showPrivacyPolicy">
							<div style="">
								<div class="w-md-50 mw-500 mx-auto lh-md" :class="width < 500 ? 'overflow-hidden' : ''">
									<component :is="currentLegalPage" :key="currentLegalPageName" @page-viewed="handlePageViewed">
									</component>
								</div>

								<div v-if="showTerms" class="w-100 w-md-50 mw-500 mx-auto pt-3 pb-2 pb-lg-2r d-flex gap-3 bg-white">
									<button class="btn btn-outline-secondary rounded-pill py-7 w-50" data-bs-dismiss="modal" @click="declineTerms">Decline</button>
									<button class="btn btn-dark rounded-pill py-7 w-50" @click="showPrivacyAcceptPage" :disabled="!termsPageViewed">Accept</button>
								</div>

								<div v-if="showPrivacyPolicy" class="w-100 w-md-50 mw-500 mx-auto pt-3 pb-2 pb-lg-2r d-flex gap-3 bg-white">
									<button class="btn btn-outline-dark rounded-pill py-7 w-50" @click="showTermsAcceptPage">Go Back</button>
									<button class="btn btn-outline-secondary rounded-pill py-7 w-50" data-bs-dismiss="modal" @click="declinePrivacyPolicy">Decline</button>
									<button class="btn btn-dark rounded-pill py-7 w-50" data-bs-dismiss="modal" @click="register" :disabled="!privacyPageViewed">Accept</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>

	<div v-if="currentView === 'verification'">
		<Verification :header="true" type="email" :mfa_email="email" purpose="email_verification" @close-verification="closeVerification" @confirmation-status="verificationCheck"></Verification>
	</div>

</template>

<script setup>
import { computed, nextTick, onMounted, ref, shallowRef, watch } from "vue";
import {useAuthStore} from "@/stores/auth-store";
import {useAppHelpers} from "@/composables/useAppHelpers";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager";
import NavButtons from "@/components/NavButtons.vue";
import AuthNav from "@/views/Auth/AuthNav.vue";
import apiClient from "@/utils/axios";
import {useWindowSize} from "@vueuse/core";
import {useRouter} from "vue-router";
import TermsContent from "@/views/TermsPages/Content.vue";
import PrivacyContent from "@/views/TermsPages/PrivacyContent.vue";
import { useToast } from "@/composables/useToast.js";
import Modal from "bootstrap/js/dist/modal";
import Verification from "@/components/GenericModalAndViews/Verification.vue";

// Initialize necessary stores and helpers
const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();
const router = useRouter();
const { width } = useWindowSize();
const currentView = ref('registration');

const registerForm = ref(null);
const formErrors = ref({});

// Define reactive references for form fields and states
const email = ref('');
const password = ref('');
const password_confirmation = ref('');
const terms = ref(false);

const passwordToggle = ref(false);
const confirmPasswordToggle = ref(false);

// Function to validate password and password confirmation
const validatePassword = () => {
    if (!password.value) {
        // helper.toast('Please enter your password to continue.', 'error');
        formErrors.value.password = 'Please enter your password to continue.';
        return false;
    }
    if (password.value.length < 8) {
        // helper.toast('Password must be at least 8 characters long.', 'error');
        formErrors.value.password = 'Password must be at least 8 characters long.';
        return false;
    }

    const number = /[0-9]/g;
    const upperCase = /[A-Z]/g;
    const specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    if (!password.value.match(upperCase)) {
        formErrors.value.password = 'Password must contain at least one uppercase letter.';
        return false;
    }
    if (!password.value.match(number)) {
        formErrors.value.password = 'Password must contain at least one number.';
        return false;
    }
    if (!password.value.match(specialChar)) {
        formErrors.value.password = 'Password must contain at least one special character.';
        return false;
    }
    if (!password_confirmation.value) {
        formErrors.value.password_confirmation = 'Please confirm your password.';
        return false;
    }
    if (password.value !== password_confirmation.value) {
        formErrors.value.password = "Password and it's confirmation do not match.";
        return false;
    }
    return true;
};

const validateEmail = () => {
    if (!email.value || email.value.trim() === "") {
        // helper.toast('Please enter your email address to continue.', 'error');
        formErrors.value.email = 'Please enter your email address to continue.';
        return false;
    }

    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let check = re.test(email.value);
    if (!check) {
        // helper.toast('Please enter a valid email address.', 'error');
        formErrors.value.email = 'Please enter a valid email address.';
    }

    return check;
}

// Function to handle user registration
const register = async () => {
	helper.loaderOn(registerForm.value);
	privacyAcceptTime.value = new Date().toISOString();
	resetTermsVariables()

	terms.value = true;

    try {
        const response = await apiClient.post('/register', {
            email: email.value,
            password: password.value,
            password_confirmation: password_confirmation.value,
            terms: terms.value ? 1 : 0,
	        terms_accept_time: termsAcceptTime.value,
	        privacy_accept_time: privacyAcceptTime.value,
        });
	    displayToast({heading: 'Registration successful', message: 'We have sent a 6-digit code to your email address.'}, 'outline-success', 8000);
        helper.loaderOff(registerForm.value);
	    currentView.value = 'verification';
    } catch (error) {
        helper.loaderOff(registerForm.value);
        let errorObj = await useHttpErrorManager().handleError(error);
        if (error.response.status === 422) {
            formErrors.value = errorObj;
	        removeFormErrorKey('full_message');
            removeFormErrorKey('alt_message');
            removeFormErrorKey('err_message');
        }
    }
};

const removePassErrorKeys = () => {
    removeFormErrorKey('password');
    removeFormErrorKey('password_confirmation');
};

const removeFormErrorKey = (key) => {
    delete formErrors.value[key];
};

const hasFormErrors = computed(() => {
    return Object.keys(formErrors.value).length > 0;
});

const performContentValidation = async () => {
	helper.loaderOn(registerForm.value);
	if (!validateEmail()) {
		helper.loaderOff(registerForm.value);
		return;
	}
	if (!validatePassword()) {
		helper.loaderOff(registerForm.value);
		return;
	}

	// Backend Validation
	try {
		const response = await apiClient.post('/auth/validateRegistrationData', {
			email: email.value,
			password: password.value,
			password_confirmation: password_confirmation.value,
		});
		helper.loaderOff(registerForm.value);
		showTermsAcceptPage();

	} catch (error) {
		helper.loaderOff(registerForm.value);
		let errorObj = await useHttpErrorManager().handleError(error);
		if (error.response.status === 422) {
			formErrors.value = errorObj;
			removeFormErrorKey('full_message');
			removeFormErrorKey('alt_message');
			removeFormErrorKey('err_message');
		}
	}
}

const currentLegalPage = shallowRef(null);
const currentLegalPageName = ref('');

const showTerms = ref(false);
const termsPageViewed = ref(false);
const termsAcceptTime = ref(null);

const showTermsAcceptPage = () => {
	termsModal.value.show();

	currentLegalPageName.value = 'terms_page_1';
	showPrivacyPolicy.value = false;
	privacyPageViewed.value = false;
	termsPageViewed.value = false;

	showTerms.value = true;
	currentLegalPage.value = TermsContent
}

const handleTermPageViewed = (val) => {
	termsPageViewed.value = val;
}

const declineTerms = () => {
	showTerms.value = false;
	currentLegalPage.value = null;
	displayToast('Registration Failed. You did not accept the Term of Service', 'outline-danger', 10000);
}

const showPrivacyPolicy = ref(false);
const privacyPageViewed = ref(false);
const privacyAcceptTime = ref(null);

const showPrivacyAcceptPage = () => {
	termsAcceptTime.value = new Date().toISOString();

	currentLegalPageName.value = 'privacy_page_2';

	showTerms.value = false;
	privacyPageViewed.value = false;
	termsPageViewed.value = false;

	showPrivacyPolicy.value = true;
	currentLegalPage.value = PrivacyContent
}
const handlePrivacyPageViewed = (val) => {
	privacyPageViewed.value = val;
}

const declinePrivacyPolicy = () => {
	showPrivacyPolicy.value = false;
	currentLegalPage.value = null;
	displayToast('Registration Failed. You did not accept the Privacy Policy', 'outline-danger', 8000);
}

const handlePageViewed = (val) => {
	if(currentLegalPage.value === TermsContent) {
		handleTermPageViewed(val);
	}
	if(currentLegalPage.value === PrivacyContent) {
		handlePrivacyPageViewed(val);
	}
}

const resetRegisterForm = () => {
	email.value = '';
	password.value = '';
	password_confirmation.value = '';
	terms.value = false;
}

const resetTermsVariables = () => {
	currentLegalPageName.value = '';
	currentLegalPage.value = null;
	showTerms.value = false;
	showPrivacyPolicy.value = false;
	termsPageViewed.value = false;
	privacyPageViewed.value = false;
}

const verificationCheck = async (val) => {
	currentView.value = 'registration';
	if(val && val[0]){
		resetRegisterForm();
		helper.loaderOff(registerForm.value);
		displayToast({
			heading: 'Verification successful',
			message: 'You have successfully verified your email address. You can now login to your account.',
		});
	}
	else{
		resetRegisterForm();
		displayToast({heading: 'Verification failed', message: 'You have failed to verify your email address.'}, 'outline-danger');
	}
}

const closeVerification = () => {
	currentView.value = 'registration';
	displayToast({heading: 'Verification Incomplete', message: 'You have not completed the verification. You will prompted again to verify your email address on next login.'}, 'outline-info');
}

const termsModal = ref(null);
onMounted(() => {
	if(currentView.value === 'registration'){
		let modalEl = document.getElementById('termsModal');
		termsModal.value = Modal.getOrCreateInstance(modalEl, {
			keyboard: false, backdrop: 'static'
		});
	}
});

watch(() => currentView.value, (val) => {
	if(val === 'registration'){
		nextTick(() => {
			let modalEl = document.getElementById('termsModal');
			termsModal.value = Modal.getOrCreateInstance(modalEl, {
				keyboard: false, backdrop: 'static'
			});
		});
	}
});
</script>

<style scoped lang="scss"></style>
